import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { NamedLink } from '../../components';

import css from './SectionHero.module.css';
import { pushToPath } from '../../util/urlHelpers';

const SectionHero = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.heroContent}>
        <h1 className={css.heroMainTitleDesktop}>
          <FormattedMessage
            id="SectionHero.titleDesktop"
            values={{ lineBreak: <br /> }} />
        </h1>
        <h1 className={css.heroMainTitleMobile}>
          <FormattedMessage
            id="SectionHero.titleMobile"
            values={{ lineBreak: <br /> }} />
        </h1>
        <h2 className={css.heroSubTitle}>
          <FormattedMessage id="SectionHero.subTitle" />
        </h2>
        <a
          className={css.heroButton}
          onClick={() => {
            pushToPath(
              '/s?address=D%C3%BCsseldorf%2C%20Nordrhein-Westfalen%2C%20Deutschland&bounds=51.85%2C7.9%2C50.55%2C6.2&mapSearch=true'
            );
          }}
        >
          <FormattedMessage id="SectionHero.browseButton" />
        </a>
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
